import { Outlet } from "@tanstack/react-router";

import { FilterBar } from "../filters/FilterBar";
import { usePageFilters } from "../../lib/pageFilters";
import { AnalyticsTabs } from "./AnalyticsTabs";

// Pathless layout route component: renders the shared section tabs and the
// Analytics-scoped filter bar above the active section. The filter is owned
// here (not per section) so one account/tag/date selection narrows every
// Analytics tab at once; each section reads the same URL filters. The tabs
// preserve the active search so switching sections keeps the filter applied.
export function AnalyticsLayout() {
  const { filters, setFilters } = usePageFilters("analytics");
  return (
    <>
      <AnalyticsTabs />
      <div className="border-b border-outline-variant px-6 py-3">
        <FilterBar
          filters={filters}
          setFilters={setFilters}
          showAccount
          showTag
          showDateRange
          aria-label="Analytics filters"
        />
      </div>
      <Outlet />
    </>
  );
}
